export default "__VITE_ASSET__CBl2WpmS__"